export default __webpack_public_path__ + "static/media/usa.348322a7.png";